import React from 'react';

export const Checked = ({ iconSize = 27 }) => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9889 10.1269C17.7867 9.92465 17.5144 9.81055 17.2291 9.81055C16.9439 9.81055 16.6716 9.92206 16.4693 10.1269L11.9752 14.5977L10.5359 13.1481C10.121 12.7331 9.43898 12.728 9.01887 13.1403C8.59617 13.5526 8.59098 14.2346 9.0059 14.6599L11.205 16.8746C11.4073 17.0769 11.6796 17.191 11.9674 17.191C12.2527 17.191 12.5224 17.0794 12.7246 16.8772L17.9838 11.6492C18.3987 11.2342 18.4039 10.5522 17.9915 10.1321L17.9889 10.1269Z"
      fill="#2ED3B7"
    />
    <path
      d="M25.4783 8.44428C24.8222 6.8961 23.8834 5.50612 22.6905 4.31062C21.495 3.11773 20.105 2.17897 18.5569 1.52287C16.9542 0.843438 15.253 0.498535 13.5 0.498535C6.33224 0.501128 0.5 6.33336 0.5 13.5011C0.5 20.6689 6.33224 26.5011 13.5 26.5011C20.6678 26.5011 26.5 20.6689 26.5 13.5011C26.5 11.7481 26.1577 10.0469 25.4783 8.44428ZM13.5 24.3513C7.51735 24.3513 2.64981 19.4838 2.64981 13.5011C2.64981 7.51848 7.51735 2.65094 13.5 2.65094C19.4826 2.65094 24.3502 7.51848 24.3502 13.5011C24.3502 19.4838 19.4826 24.3513 13.5 24.3513Z"
      fill="#2ED3B7"
    />
  </svg>
);
